export function getQuoteRequest(data, addon) {
    const { currency, language, guests, date, startDate, endDate, quantity } = data;
    const result = {
        addonId: addon.id,
        currency,
        language,
    };
    switch (addon.dateType) {
        case 'DATE_RANGE':
            result.startDate = startDate;
            result.endDate = endDate;
            break;
        case 'ONLY_DATE':
            result.date = date;
            break;
    }
    if (addon.hasNumberPersons) {
        switch (addon.chargeType) {
            case 'PERSON_PRICE':
                result.people = guests.adults;
                break;
            default:
                result.adults = guests.adults;
                result.children = guests.childrenAges.map((c) => c.age);
                break;
        }
    }
    if (addon.hasQuantity) {
        result.quantity = quantity;
    }
    return result;
}
export function getSaveTripRequest(addOn, item, currency, hotelId, language, quoteData) {
    let quantities = {};
    switch (addOn.chargeType) {
        case 'AGES_PRICE':
            quantities = {
                type: 'PEOPLE',
                adults: quoteData.guests.adults,
                children: quoteData.guests.childrenAges.map(c => c.age)
            };
            break;
        case 'PERSON_PRICE':
            quantities = {
                type: 'FIXED_PEOPLE',
                people: quoteData.guests.adults
            };
            break;
        case 'UNIT_PRICE':
            quantities = {
                type: 'FIXED',
                value: quoteData.quantity
            };
            break;
    }
    return {
        total: item.amount,
        currency,
        language,
        hotelId,
        items: [
            {
                serviceType: 'ADDON',
                id: item.id,
                schedule: Object.assign({}, addOn.dateType === 'DATE_RANGE' ? {
                    type: 'TIME_FRAME',
                    startDate: quoteData.startDate || '',
                    endDate: quoteData.endDate || ''
                } : {
                    type: 'DATE',
                    startDate: quoteData.date || '',
                }),
                quantities: [quantities]
            }
        ]
    };
}
